<template>
    <div class="index" :style="height">
        
        <el-container :style="height">
            <el-header>
                <div class="header-top">
                    <div class="header">
                        <div class="l">
                            <div class="logotitle">
                                <div class="logo">
                                    <!-- <img src="../../assets/images/icon06.png" alt=""> -->
                                    <img src="../../assets/images/icon19.png" alt="">
                                </div>
                                <span slot="title" style="margin-left:15px">恋TA系统</span>
                            </div>
                          

                            <div class="tag">

                            </div>

                        </div>
                        <div class="r">
                            <div class="autocomplete">
                                <!-- <el-autocomplete
                                    class="inline-input"
                                    v-model="searchValue"
                                    :fetch-suggestions="querySearch"
                                    placeholder="搜索..."
                                    @select="handleSelect"
                                    @keyup.enter.native="search"
                                    size="small"
                                >
                                    <template slot-scope="{ item }">
                                        <div class="name">{{ item.label }}</div>
                                    </template>
                                </el-autocomplete> -->
                            </div>
                            <!-- <el-popover
                                placement="bottom"
                                title="操作手册"
                                width="110"
                                trigger="hover"
                                >
                                <div class="document-btns">
                                    <div>
                                        <el-button icon="el-icon-share" type="text" @click="operationManual(1)">总部后台</el-button>
                                    </div>
                                    <div>
                                        <el-button icon="el-icon-share" type="text" @click="operationManual(2)">机构后台</el-button>
                                    </div>
                                    <div>
                                        <el-button icon="el-icon-share" type="text" @click="operationManual(3)">调查员后台</el-button>
                                    </div>
                                </div>
                                
                                <el-button slot="reference" type="text" icon="el-icon-document" size="" style="margin-right:20px;font-size: 18px;color:#ffffff"></el-button>
                            </el-popover> -->
                            <el-button type="text" icon="el-icon-aim" size="" style="font-size: 18px;color:#ffffff" @click="aim" v-if="isFullScreen"></el-button>
                            <el-button type="text" icon="el-icon-full-screen" size="" style="font-size: 18px;color:#ffffff" @click="fullScreen" v-else></el-button>
                            <!-- <el-button type="text" icon="el-icon-setting" style="margin-right:10px;margin-left:20px;font-size: 18px;color:#ffffff" @click="goUpdatePassword"></el-button> -->
                            <el-button type="text" icon="el-icon-switch-button" @click="quit" style="margin-right:20px;font-size: 18px;color:#ffffff"></el-button>
                            <!-- <img src="../../assets/images/user.png" alt=""> -->
                            <el-image
                            class='headerimg'
                            :src="userData.avatar"
                            :fit="fit" v-if="userData.avatar"></el-image>
                            <img src="../../assets/images/user.png" alt="" v-else>
                            <div class="r-span"><div class="name" :style="widthName" @click="changeShenhe">
                                <!-- 管理者 -->
                                {{userData.teamName}}管理者您好！
                            </div></div> 
                        </div>
                    </div>
                </div>
                
                
            </el-header>
           
           
        
            <el-container class="container" :style="height">
                <el-aside class="aside" :style="widthAside">
                    <el-menu :default-active="menuIndex" 
                    :collapse="isCollapse" 
                    @select="selectMenu" 
                    unique-opened="true" 
                    class="el-menu-vertical-demo"
                    background-color="#ffffff"
                    text-color="#222222"
                    active-text-color="#222222"
                    v-if="tagItemIndex==0||tagItemIndex==-1"
                    >   
                        
                        <el-submenu index="0">
                            <template slot="title">
                                <i class="el-icon-s-platform"></i>
                                <span slot="title">统计总览</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="0-1" name="统计总览" path="console">控制台</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>

                        <el-submenu index="1">
                            <template slot="title">
                                <i class="el-icon-user-solid"></i>
                                <span slot="title">用户管理</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="1-1" name="用户列表" path="user">用户列表</el-menu-item>
                                <el-menu-item index="1-2" name="未完善用户" path="user1">未完善用户</el-menu-item>
                                <el-menu-item index="1-3" name="封禁用户" path="user2">封禁用户</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                       
                        <el-submenu index="2">
                            <template slot="title">
                                <i class="el-icon-user-solid"></i>
                                <span slot="title">动态管理</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="2-1" name="动态管理" path="dynamic">动态管理</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>

                        <el-submenu index="3" v-if="lianta_issh!='1'">
                            <template slot="title">
                                <i class="el-icon-user-solid"></i>
                                <span slot="title">聊天管理</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="3-1" name="聊天列表" path="message1">聊天列表</el-menu-item>
                                <el-menu-item index="3-2" name="会话列表" path="message2">会话列表</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>

                        <el-submenu index="4">
                            <template slot="title">
                                <i class="el-icon-user-solid"></i>
                                <span slot="title">认证管理</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="4-1" name="实名认证" path="idCar">实名认证</el-menu-item>
                                <el-menu-item index="4-2" name="学历认证" path="education">学历认证</el-menu-item>
                                <el-menu-item index="4-3" name="房产认证" path="realEstate">房产认证</el-menu-item>
                                <el-menu-item index="4-4" name="车辆认证" path="vehicle">车辆认证</el-menu-item>
                                <el-menu-item index="4-5" name="职业认证" path="career">职业认证</el-menu-item>
                                <el-menu-item index="4-6" name="收入认证" path="income">收入认证</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                        <el-submenu index="7">
                            <template slot="title">
                                <i class="el-icon-user-solid"></i>
                                <span slot="title">支付管理</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="7-1" name="微信支付" path="wxPay">微信支付</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                        <el-submenu index="5">
                            <template slot="title">
                                <i class="el-icon-user-solid"></i>
                                <span slot="title">音视频管理</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="5-1" name="音视频认证" path="fileAudit">音视频认证</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                        <el-submenu index="6">
                            <template slot="title">
                                <i class="el-icon-user-solid"></i>
                                <span slot="title">用户反馈</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="6-1" name="用户反馈" path="feedback">用户反馈</el-menu-item>
                                <el-menu-item index="6-2" name="用户申诉" path="appeal">用户申诉</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                        <el-submenu index="7">
                            <template slot="title">
                                <i class="el-icon-user-solid"></i>
                                <span slot="title">审核模式管理</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="7-1" name="小程序管理" path="wcxAudit">小程序管理</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                    </el-menu>
                </el-aside>
                <el-container :style="height">
                    <el-main>
                        
                        <el-col :span="24" v-if="title">
                            <div class="main-title">
                                <i class="el-icon-s-operation"></i>
                                {{title}}
                                <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
                                    <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
                                </el-breadcrumb> -->
                            </div>

                        </el-col>
                        
                        <router-view class="routerview">
                            
                        </router-view>
                    </el-main>
                    <el-footer style="height:45px">
                        <el-col :span="24">
                            <div class="main-tip">
                                Copyright©2022-2026 | 长沙伊人科技有限公司版权所有
                            </div>
                        </el-col>
                    </el-footer>
                </el-container>
            </el-container>
        </el-container>
        <!-- <el-dialog title="" :visible.sync="loginDialog" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" width="100%" :fullscreen="true" top="0">
            <div style="width:450px;margin:120px auto">
                <div class="dialogheader">
                    <img src="../../assets/images/user.png" alt="">
                </div>
                <forms ref="formListLogin" :list="formList" :value="formData" :rules="formRules" :btns="formLogin" labelWidth="120px"></forms>
            </div>
            
        </el-dialog> -->
    </div>
</template>
<script>
import api from '../../api/main'
import App from '../../App.vue';
import store from '../../store';
import forms from '../../components/form'
export default {
  components: { App,forms },
  
    name: 'index',
    data () {
        return {
            lianta_issh:localStorage.getItem('lianta_issh'),
            height:'100%',
            isCollapse:false,
            nameList:['控制台'],
            tabs:[{
                title: '控制台',
                path: 'console',
                index:0
            }],
            tabsValue:'console',
            menus:[],
            role:'',
            menuIndex:0,
            parentMenuIndex:0,
            isFullScreen:false,
            name:localStorage.getItem('name'),
            
            searchValue:'',
            formData:{
                acount:'',
                password:'',
            },
            formList:[
                // {type: "input",label: "账号:",name: "acount",},
                {type: "password",label: "解锁密码:",name: "password"},
                
            ],
            formLogin:[
                {name:'登录',icon:'el-icon-success',type:'primary',handleClick:this.login,size:'medium '},
            ],
            formRules:{
                // acount: [{ required: true, message: '请填写账号', trigger: 'blur' }],
                password: [{ required: true, message: '请填写密码', trigger: 'blur' }],
            },
            // loginDialog:true,

            userData:{},
            tagItemIndex:0,
            title:'',
            widthAside:'width:226px',
            widthName:'',
        }
    },
    created(){
        

    },
    mounted(){
        
        
        // this.userData = JSON.parse(localStorage.getItem('lianta_agentData'))
        this.getHeight();
        this.tagItemIndex = sessionStorage.getItem('tagItemIndex')?sessionStorage.getItem('tagItemIndex'):0
        this.menuIndex = sessionStorage.getItem('menuIndex')?sessionStorage.getItem('menuIndex'):0
        this.parentMenuIndex = sessionStorage.getItem('parentMenuIndex')?sessionStorage.getItem('parentMenuIndex'):0
        this.title = sessionStorage.getItem('title')?sessionStorage.getItem('title'):0
        if (this._isMobile()) {
            this.showMenu();
            this.widthAside = 'width:60px'
            this.widthName = 'width:60px'
        } else {
            this.widthAside = 'width:226px'
            this.widthName = ''

        }
        
    },
    methods:{
        changeShenhe(){
            if(!localStorage.getItem('lianta_issh')){
                localStorage.setItem('lianta_issh','1')
            }else if(localStorage.getItem('lianta_issh') == '0'){
                localStorage.setItem('lianta_issh','1')
            }else if(localStorage.getItem('lianta_issh') == '1'){
                localStorage.setItem('lianta_issh','0')
            }
        },
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },

        // login(){
        //     if(this.formData.password=="123456"){
        //         this.$message({
        //             message: '登录成功',
        //             type: 'success'
        //         });
        //         this.loginDialog = false;
        //     }   
        // },
        operationManual(index){
            if(index==1){
                window.open('http://120.24.255.164:4999/web/#/5/23');
            }else if(index==2){
                window.open('http://120.24.255.164:4999/web/#/6/29');
            }else if(index==3){
                window.open('http://120.24.255.164:4999/web/#/7/34');
            }
        },
        tagItemChange(index){
            this.tagItemIndex = index;
            if(index==-1){
                this.menuIndex = '0-1',
                this.parentMenuIndex = '0',
                this.$router.push({name:'console'});
            }

            sessionStorage.setItem('tagItemIndex',index)
        },
        

        // 获取菜单
        async getUserMenu(){
            let res  = await api.queryResource();
            this.menus = res.data.data;
        },






        querySearch(){},
        handleSelect(){},
        search(){},
        // 关闭其他
        closeTabOther(){
            for(let i = 1;i<this.tabs.length;i++){
                if(this.tabs[i].path == this.tabsValue){
                    this.tabs = [this.tabs[0],this.tabs[i]]
                }else{
                }
            }
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },    
        // 关闭左侧
        closeTabLeft(){
            for(let i = 1;i<this.tabs.length;){
                if(this.tabs[i].path == this.tabsValue){
                    store.dispatch('global/setTabs', this.tabs);
                    store.dispatch('global/setTabsValue', this.tabsValue);
                    return;
                }else{
                    this.tabs.splice(i,1);
                }
            }
        },
        // 关闭右侧
        closeTabRight(){
            let startIndex = 1;
            for(let i = 1;i<this.tabs.length;i++){
                if(this.tabs[i].path == this.tabsValue){
                    startIndex = i+1;
                    continue;
                }
            }
            for(startIndex;startIndex<this.tabs.length;){
                this.tabs.splice(startIndex,1);
            }
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },
        // 关闭所有
        closeTabAll(){
            this.tabs = [this.tabs[0]];
            this.tabsValue = this.tabs[0].path;
            this.parentMenuIndex = 0;
            this.nameList = ['控制台'];
            this.$router.push({name:this.tabsValue});
            this.menuIndex = this.tabs[0].index
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
            this.nameList = route.$attrs.name.split('>');
        },
        //获取浏览器的当前的高度
        getHeight(){
            let _this = this;
            _this.height =  'height:'+(document.body.clientHeight-60)+'px';
            window.onresize = function(){
                _this.height =  'height:'+(document.body.clientHeight-60)+'px';
            }
        },
        // 选择左侧菜单
        selectMenu(index,path,route){
            console.log(route.$attrs.name);
            console.log(route);
            
            if(route.$attrs.path=='allAnXinCase'||route.$attrs.path=='anxinCaseAdd'||route.$attrs.path=='indexZY'){
            }else{
            }
            this.$router.push({name:route.$attrs.path});

            this.menuIndex = index;
            this.parentMenuIndex = this.menuIndex.split('-')[0];
            this.nameList = route.$attrs.name.split('>');
            this.title = this.nameList[0];
            sessionStorage.setItem('title',this.title);
            sessionStorage.setItem('menuIndex',this.menuIndex);
            sessionStorage.setItem('parentMenuIndex',this.parentMenuIndex);
            // store.dispatch('global/setTabsValue', route.$attrs.path);
            // this.tabsValue = route.$attrs.path;
            // for(let i=0;i<this.tabs.length;i++){
            //     if(this.tabs[i].path == route.$attrs.path){
            //         store.dispatch('global/setTabsValue', this.tabsValue);
            //         return;
            //     }
            // }
            // this.tabs.push({
            //     title: this.nameList[0],
            //     path: route.$attrs.path,
            //     index:index,
            //     nameList:this.nameList,
            // });
            // this.tabsValue = route.$attrs.path;
            // store.dispatch('global/setTabs', this.tabs);
           
        },
        // 查询页面操作权限
        async queryPermissionMenuOperation(path){
            for(let i in this.menus){
                for(let j in this.menus[i].children){
                    if(this.menus[i].children[j].path == path){
                        let res = await api.queryPermissionMenuOperation(this.menus[i].children[j].id);
                        localStorage.setItem('btns',JSON.stringify(res.data.data))
                        this.$router.push({name:path});
                        return;
                    }
                }
            }
        },
        // 跳转到更新密码页面
        goUpdatePassword(){
            this.$router.push({name:'updatePassword'});
        },
        // 显示隐藏菜单栏
        showMenu(){
            this.isCollapse = !this.isCollapse
        },
        
        // 切换tab
        clickTab(e){
            this.$router.push({name:this.tabs[e.index].path});
            this.menuIndex = this.tabs[e.index].index?this.tabs[e.index].index:false;
            if(this.menuIndex){
                this.parentMenuIndex = this.menuIndex.split('-')[0];
                localStorage.setItem('taskStatus',this.menuIndex.split('-')[1]);
                this.nameList = this.tabs[e.index].nameList;
            }else{
                this.parentMenuIndex = 0;
                this.menuIndex = 0;
                this.nameList = ['控制台']
            }
            store.dispatch('global/setTabsValue', this.tabsValue);
        },
        // 关闭tab
        removeTab(targetName){
            if(this.tabsValue === targetName){
                this.tabs.forEach((tab,index) => {
                    if(tab.path === targetName) {
                        console.log(this.tabs[index-1]);
                        this.menuIndex = this.tabs[index-1].index ? this.tabs[index-1].index : 0;
                        if(this.menuIndex == 0){
                            this.parentMenuIndex = 0;
                        }
                        this.tabsValue = this.tabs[index-1].path;
                        this.$router.push({name:this.tabsValue});
                        this.nameList = this.tabs[index-1].nameList?this.tabs[index-1].nameList:['控制台'];
                        return;
                    }
                })
            }
            this.tabs = this.tabs.filter(tab => tab.path !== targetName);
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },
        // 退出登录
        quit(){
            this.$confirm('将退出登录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '退出成功!'
                });
                store.dispatch('global/setTabs', []);
                store.dispatch('global/setTabsValue', '');

                localStorage.removeItem('lianta_accessToken');
                localStorage.removeItem('lianta_userData');
                localStorage.removeItem('lianta_agentData');
                this.$router.push({ name: 'login' });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        
        // 全屏
        fullScreen(){
            var docElm = document.documentElement;  
            //W3C   
            if (docElm.requestFullscreen) {  
                docElm.requestFullscreen();  
            }  
                //FireFox   
            else if (docElm.mozRequestFullScreen) {  
                docElm.mozRequestFullScreen();  
            }  
                //Chrome等   
            else if (docElm.webkitRequestFullScreen) {  
                docElm.webkitRequestFullScreen();  
            }  
                //IE11   
            else if (elem.msRequestFullscreen) {  
                elem.msRequestFullscreen();  
            }  
            this.isFullScreen = true;
        },
        aim(){
            if (document.exitFullscreen) {  
                document.exitFullscreen();  
            }  
            else if (document.mozCancelFullScreen) {  
                document.mozCancelFullScreen();  
            }  
            else if (document.webkitCancelFullScreen) {  
                document.webkitCancelFullScreen();  
            }  
            else if (document.msExitFullscreen) {  
                document.msExitFullscreen();  
            }  
            this.isFullScreen = false;

        },
        
        
    }
    
}
</script>

<style lang="scss" scoped>
   
    .index{
        background-color: #ffffff;
        min-height: 100%;
        .dialogheader{
            width: 100%;
            display: flex;
            justify-content: center;
            img{
                width: 100px;
                height: 100px;
            }
        }
        
        .document-btns{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        /deep/.el-container{
           .aside{
                border-right: 1px solid #e8e9ed;
           }
        }
        /deep/.el-badge__content--warning{
            background: #f90;
            border-color:#f90;
        }
        /deep/.el-menu-item-group{
            .el-menu-item{
                background-color: #ffffff!important;
                padding-left: 54px!important;
            }
        }
        /deep/.el-menu{
            border-right: 0;
            overflow: hidden;
            .is-active{
                background: #e8f0fb!important;
                color: #2b60dd !important;
                .el-submenu__title{
                    color: #2b60dd !important;
                }
                i{
                    color: #2b60dd !important;
                }
            }

            
        } 
        
        /deep/.el-menu-item{
            display: flex;
            align-items: center;
            i{
                color:hsla(0,0%,100%,.7);
                margin-right:10px;
            }
            .badge{
                height: 50px;
                margin-bottom: 16px;
                margin-left: 4px;
            }
        }
        /deep/.el-submenu__title{
            i{
                color:#00174d;
                margin-right:10px;
            }
        }
        /deep/.el-submenu__title:hover{
            background-color: #e8f0fb !important;
        }
        /deep/.el-menu-item-group__title{
            padding:0;
        } 
        /deep/.el-header{
            height: 60px !important;
            padding: 0;
            
            .header-top{
                width: 100%;
                height: 60px;
                // background-color: #ffffff;
                // position: relative;
                z-index: 10;
                box-shadow: 0 1px 4px rgba(0,21,41,.08);
                background-color: #2b60dd;
            }
            .header{
                background-color: #2b60dd;
                width: 100%;
                height: 60px;
                margin-bottom: 2px;
                // border-bottom: 1px solid #DEDEDE;
                display: flex;
                align-items: center;
                justify-content: space-between;
                overflow: hidden;

                .l{
                    height: 21px;
                    margin-left: 15px;
                    display: flex;
                    align-items: center;
                    .logotitle{
                        height: 60px;
                        font-size: 18px;
                        display: flex;
                        align-items: center;
                        color: #ffffff;
                        // border-bottom: 1px solid #101117;
                        background-color: #2b60dd;
                        padding-left: 14px;
                        // .logo{
                        //     width: 36px;
                        //     height: 36px;
                        //     border-radius: 50%;
                        //     background-color: #FFFFFF;
                        //     display: flex;
                        //     align-items: center;
                        //     justify-content: center;
                        // }
                        // img{
                        //     width: 32px;
                        //     height: 19px;
                        //     margin-bottom: 2px;
                        // }
                        .logo{
                            width: 36px;
                            height: 36px;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        img{
                            width: 36px;
                            height: 36px;
                        }
                        span{
                            overflow: hidden;
                            width: 150px;
                            white-space:nowrap;
                        }
                    }
                    img{
                        width: 15px;
                        height: 12px;
                        cursor: pointer;
                    }

                    .breadcrumb{
                        width: 100px;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                        .el-breadcrumb{
                            margin-left: 5px!important;
                            .el-breadcrumb__inner{
                                font-size: 14px;
                                // font-weight: bold;
                                color: #ffffff !important;
                            }
                        }
                        
                    }
                    
                    .tag{
                        display: flex;
                        align-items: center;
                        .tag-item-this{
                            border-radius: 5px;
                            background-color: hsla(0,0%,100%,.9);
                            color: #2b60dd;
                            padding: 8px 20px;
                            margin-right: 13px;
                            font-size: 15px;
                            line-height: 20px;
                            cursor: pointer;
                            position:relative;
                        }
                        .tag-item{
                            border-radius: 5px;
                            background-color: #2b60dd;
                            color: #FFFFFF;
                            padding: 8px 20px;
                            margin-right: 13px;
                            font-size: 15px;
                            line-height: 20px;
                            cursor: pointer;
                            position:relative;
                        }
                        .tag-badge{
                            top: 0;
                            right: -10px;
                            position:absolute;
                        }
                    }
                }
                .r{
                    height:46px;
                    display: flex;
                    align-items: center;
                    .autocomplete{
                        margin-right: 25px;
                    }
                    .headerimg{
                        width: 26px;
                        height: 26px;
                        border-radius: 50%;
                        margin-right: 4px;
                    }
                    .r-span{
                        line-height: 46px;
                        margin-right: 20px;
                        font-size: 14px;
                        .name{
                            color: #ffffff;
                            margin-right: 0;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                       
                    }
                    img{
                        width: 26px;
                        margin-right: 4px;
                    }
                    /deep/.el-button{
                        i{
                            font-size: 16px !important;
                        }
                    }
                }
                .popover{
                    width: 100px;
                    border:1px solid #ffffff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
            }
            .tabs{
                // background-color: #FFFFFF;
                padding: 8px;
                box-shadow: 0 1px 4px rgba(0,21,41,.08);
                height: 36px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                z-index: 9;
                // border-bottom: 1px solid #DEDEDE;
                .el-tabs--card>.el-tabs__header{
                    border: 0;
                }
                .el-tabs--card>.el-tabs__header .el-tabs__nav{
                    border: 0;
                    background-color: #FFFFFF;
                }
                .el-tabs__header{
                    margin: 0;
                }
                .el-tabs--card>.el-tabs__header .el-tabs__item{
                    border: 1px solid #e4e7ed;
                    border-radius: 5px;
                    margin-right: 10px;
                    height: 36px;
                    line-height: 36px;
                    padding: 0 18px;
                }
                .el-tabs__nav .el-tabs__item:nth-child(1) .el-icon-close{
                    display: none;
                }
                .el-tabs{
                    padding-right: 30px;
                }
                .el-tabs__nav-next, .el-tabs__nav-prev{
                    line-height: 35px;
                }
                .tabs-l{
                    width: 100%;
                }
                .tabs-r{
                    height: 40px;
                    display: flex;
                    align-items: center;
                    font-size: 20px;
                    position:absolute;
                    right: 12px;
                    cursor: pointer;
                    .i{
                        font-size: 24px;
                    }
                }
                .handle{
                    // border: 1px solid #000000;
                    display: none;
                    width: 100px;
                    height: 100px;
                    position: absolute;
                    right: 2px;
                    top: 30px;
                    z-index: 9999;
                    background-color: #ffffff;
                    box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
                    padding: 6px 0;
                    transition: .3s;
                }

                .handle-item{
                    padding-left: 12px;
                    height: 25px;
                    line-height: 22px;
                    font-size: 13px;
                    color: #222222;
                    cursor: pointer;
                    transition: .3s;
                    i{
                        font-size: 14px;
                    }
                }
                .tabs-r:hover .handle{
                    display: block;
                }
                .handle-item:hover{
                    color: #999999;
                }
            }
        }
        /deep/.el-main{
            padding: 10px;
            padding-top: 0px;
            flex: auto;
            background-color: #f5f5f5;
            
        }
        .main-title{
            background-color: #ffffff;
            border-radius: 4px;
            margin-top: 10px;
            margin-bottom: 10px;
            padding: 12px 15px;
            font-size: 15px;
            // font-weight: bold;
        }
        /deep/.el-footer{
            background-color: #f5f5f5;
        }
        .main-tip{
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            color: #707070;
            text-align: center;
            margin-top: 10px;
        }
        /deep/.el-menu--collapse{
            width: 64px;
            .el-menu-item{
                display: flex;
                // justify-content: center;
            }
        } 
        /deep/.el-submenu__title{
            width: 220px;
        }
        .el-menu-vertical-demo:not(.el-menu--collapse) {
            width: 220px;
            min-height: 400px;
            // box-shadow: 2px 0 6px 0 rgba(0,21,41,.3)
        }
        
        
    }
    
  
</style>
